import { useQuery } from '@tanstack/react-query';
import { bannerApi } from './client';

export const useBanners = () =>
  useQuery({
    queryKey: ['banners'],
    queryFn: bannerApi.getAll,
  });
